import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import uuid from 'uuid';
import { mention } from '@atlaskit/adf-schema';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { IconMention } from '@atlaskit/editor-common/quick-insert';
import { ELEMENTS_CHANNEL } from '@atlaskit/mention/resource';
import { mentionPluginKey } from './pm-plugins/key';
import { createMentionPlugin } from './pm-plugins/main';
import { createTypeAheadConfig } from './type-ahead';
import { SecondaryToolbarComponent } from './ui/SecondaryToolbarComponent';
var mentionsPlugin = function mentionsPlugin(_ref) {
  var options = _ref.config,
    api = _ref.api;
  var sessionId = uuid();
  var fireEvent = function fireEvent(payload) {
    var _api$analytics$shared, _api$analytics;
    var _ref2 = (_api$analytics$shared = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.sharedState.currentState()) !== null && _api$analytics$shared !== void 0 ? _api$analytics$shared : {},
      createAnalyticsEvent = _ref2.createAnalyticsEvent;
    if (!createAnalyticsEvent) {
      return;
    }
    if (payload.attributes && !payload.attributes.sessionId) {
      payload.attributes.sessionId = sessionId;
    }
    createAnalyticsEvent(payload).fire(ELEMENTS_CHANNEL);
  };
  var typeAhead = createTypeAheadConfig({
    sanitizePrivateContent: options === null || options === void 0 ? void 0 : options.sanitizePrivateContent,
    mentionInsertDisplayName: options === null || options === void 0 ? void 0 : options.insertDisplayName,
    HighlightComponent: options === null || options === void 0 ? void 0 : options.HighlightComponent,
    fireEvent: fireEvent,
    api: api
  });
  return {
    name: 'mention',
    nodes: function nodes() {
      return [{
        name: 'mention',
        node: mention
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'mention',
        plugin: function plugin(pmPluginFactoryParams) {
          return createMentionPlugin(pmPluginFactoryParams, fireEvent, options);
        }
      }];
    },
    secondaryToolbarComponent: function secondaryToolbarComponent(_ref3) {
      var editorView = _ref3.editorView,
        disabled = _ref3.disabled;
      return /*#__PURE__*/React.createElement(SecondaryToolbarComponent, {
        editorView: editorView,
        api: api,
        disabled: disabled,
        typeAhead: typeAhead
      });
    },
    actions: {
      openTypeAhead: function openTypeAhead(inputMethod) {
        var _api$typeAhead;
        return Boolean(api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 || (_api$typeAhead = _api$typeAhead.actions) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.open({
          triggerHandler: typeAhead,
          inputMethod: inputMethod
        }));
      }
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      var mentionPluginState = mentionPluginKey.getState(editorState);
      return _objectSpread(_objectSpread({}, mentionPluginState), {}, {
        typeAheadHandler: typeAhead
      });
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref4) {
        var formatMessage = _ref4.formatMessage;
        return [{
          id: 'mention',
          title: formatMessage(messages.mention),
          description: formatMessage(messages.mentionDescription),
          keywords: ['team', 'user'],
          priority: 400,
          keyshortcut: '@',
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconMention, null);
          },
          action: function action(insert, state) {
            var _api$typeAhead2;
            var tr = insert(undefined);
            var pluginState = mentionPluginKey.getState(state);
            if (pluginState && pluginState.canInsertMention === false) {
              return false;
            }
            api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 || _api$typeAhead2.actions.openAtTransaction({
              triggerHandler: typeAhead,
              inputMethod: INPUT_METHOD.QUICK_INSERT
            })(tr);
            return tr;
          }
        }];
      },
      typeAhead: typeAhead
    }
  };
};
export { mentionsPlugin };